import i18n from '@/locales/index'
const tipsList = [
  {
    index: 1,
    content: [
      {
        options: [
          i18n.t('upgrade_page_views_settled_in_question_tips_1207')
        ]
      }
    ]
  },
  {
    index: 2,
    content: [
      {
        options: [
          i18n.t('upgrade_page_views_settled_in_question_tips_1208'),
          i18n.t('upgrade_page_views_settled_in_question_tips_1209'),
          i18n.t('upgrade_page_views_settled_in_question_tips_1210'),
          i18n.t('upgrade_page_views_settled_in_question_tips_1211')
        ]
      }
    ]
  },
  {
    index: 3,
    content: [
      {
        options: [
          i18n.t('upgrade_page_views_settled_in_question_tips_1212'),
          i18n.t('upgrade_page_views_settled_in_question_tips_1213')
        ]
      }
    ]
  },
  {
    index: 4,
    content: [
      {
        options: [
          i18n.t('upgrade_page_views_settled_in_question_tips_1214')
        ]
      }
    ]
  },
  {
    index: 5,
    content: [
      {
        options: [
          i18n.t('upgrade_page_views_settled_in_question_tips_1215')
        ]
      }
    ]
  },
  {
    index: 6,
    content: [
      {
        options: [
          i18n.t('upgrade_page_views_settled_in_question_tips_1216')
        ]
      }
    ]
  }
];

export default tipsList;
